export default {"src":"/_next/static/media/staking_top_right_icon_mobile.f667d7ac.svg","height":31,"width":103,"blurWidth":0,"blurHeight":0};